<template>
    <div id="header-nav" class="headerNav" v-show="!hideCat">
        <!-- web-->
        <div
            :key="6"
            :id="`nav_${viewList[0].name}`"
            class="navItem"
            :class="{
                activeNavItem: isCurrentRoute(viewList[0].name),
            }"
            @click="setCurrentMode(viewList[0])"
        >
            <router-link
                v-if="currentMode"
                :id="`nav-link_${viewList[0].name}`"
                class="navLink"
                :to="{
                    name: viewList[0].name,
                    query: queryParameters,
                }"
                @click="currentMode.name = viewList[0].name"
            >
                <img
                    :id="`nav-icon_${viewList[0].name}`"
                    class="navIcon"
                    :src="viewList[0].icon"
                />{{ viewList[0].name || "Web" }}</router-link
            >
        </div>
        <!-- end of web-->

        <div class="navItem">
            <a
                id="nav-link_images"
                class="navLink"
                :href="
                    `https://images.search.yahoo.com/yhs/search?p=${
                        enteredQuery ? enteredQuery : ''
                    }&type=${typeTag}`
                "
                target="_blank"
                @click="trackGA('click', { label: 'images' })"
            >
                <img
                    id="nav-link_Images"
                    src="/assets/images/common/icon_images.svg"
                />
                Images</a
            >
        </div>

        <div class="navItem">
            <a
                id="nav-link_video"
                class="navLink"
                :href="
                    `https://video.search.yahoo.com/yhs/search?p=${
                        enteredQuery ? enteredQuery : ''
                    }&type=${typeTag}`
                "
                target="_blank"
                @click="trackGA('click', { label: 'video' })"
            >
                <img
                    id="nav-link_Video"
                    class="navLink"
                    src="/assets/images/common/icon_video.svg"
                />
                Video</a
            >
        </div>

        <div class="navItem">
            <a
                id="nav-link_news"
                class="navLink"
                :href="
                    `https://news.search.yahoo.com/search?p=${
                        enteredQuery ? enteredQuery : ''
                    }&type=${typeTag}`
                "
                target="_blank"
                @click="trackGA('click', { label: 'news' })"
            >
                <img
                    id="nav-link_News"
                    class="navLink"
                    src="/assets/images/common/icon_news.svg"
                />
                News</a
            >
        </div>

        <div class="navItem">
            <a
                id="nav-link_shopping"
                class="navLink"
                :href="
                    `https://shopping.yahoo.com/search?p=${
                        enteredQuery ? enteredQuery : ''
                    }&type=${typeTag}`
                "
                target="_blank"
                @click="trackGA('click', { label: 'shopping' })"
            >
                <img
                    id="nav-link_Shopping"
                    class="navLink"
                    src="/assets/images/common/icon_shopping.svg"
                />
                Shopping</a
            >
        </div>

        <!--reordered links-->
        <div
            v-for="(navItem, index) in reorderedViewList"
            :key="index"
            :id="`nav_${navItem.name}`"
            class="navItem yah"
            :class="{
                activeNavItem: isCurrentRoute(navItem.name),
            }"
            @click="setCurrentMode(navItem)"
        >
            <router-link
                v-if="currentMode"
                :id="`nav-link_${navItem.name}`"
                class="navLink"
                :to="{
                    name: navItem.name,
                    query: queryParameters,
                }"
                @click="currentMode.name = navItem.name"
            >
                <img
                    :id="`nav-icon_${navItem.name}`"
                    class="navIcon"
                    :src="navItem.icon"
                />{{ navItem.name || "Web" }}</router-link
            >

            <a
                v-if="!currentMode"
                :id="`nav-link_${navItem.name}`"
                class="navLink"
                :href="`${navItem.path.substring(1)}${querySearch}`"
                @click="currentMode.name = navItem.name"
            >
                <img
                    :id="`nav-icon_${navItem.name}`"
                    class="navIcon"
                    :src="navItem.icon"
                />{{ navItem.name }}</a
            >
        </div>
        <!-- end of reordered links -->

        <div id="yahoo-links-more" class="navItem more dropdown">
            <a id="nav-link_more" class="navLink dropbtn" href="#">
                <img
                    id="nav-link_More"
                    class="navLink"
                    src="/assets/images/common/icon_more.svg"
                />
                More</a
            >
            <div class="dropdown-content">
                <div
                    v-for="(navItem, index) in reorderedViewList"
                    :key="index"
                    :id="`nav_${navItem.name}`"
                    :class="{
                        activeNavItem: isCurrentRoute(navItem.name),
                    }"
                    @click="setCurrentMode(navItem)"
                >
                    <router-link
                        v-if="currentMode"
                        :to="{
                            name: navItem.name,
                            query: queryParameters,
                        }"
                        @click="currentMode.name = navItem.name"
                    >
                        <img
                            :id="`nav-icon_${navItem.name}`"
                            class="moreLink"
                            :src="navItem.icon"
                        />{{ navItem.name || "Web" }}</router-link
                    >
                    <a
                        v-if="!currentMode"
                        :href="`${navItem.path.substring(1)}${querySearch}`"
                        @click="currentMode.name = navItem.name"
                    >
                        <img
                            :id="`nav-icon_${navItem.name}`"
                            class="moreLink"
                            :src="navItem.icon"
                        />{{ navItem.name }}</a
                    >
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import queryString from "query-string";
import { documentReady, getTypeTag, setSearchHistory } from "@/common";
import {
    verticalList,
    reorderedVerticalList,
    defaultVertical,
} from "@/linkLists";
import { pageviewEvent, searchEvent, trackGA } from "@/analytics";

export default {
    name: "reordered-freshy-header",
    props: ["query", "enteredQuery"],
    data() {
        const qs = queryString.parse(window.location.search);
        return {
            typeTag: qs.type || null,
            routerKey: 0,
            viewList: verticalList,
            reorderedViewList: reorderedVerticalList,
            currentMode: this.$route,
            isAutoFill: false,
            hideCat: false,
            trackGA,
        };
    },
    mounted() {
        documentReady.then(() => {
            // check for typetag and fix if necessary
            if (this.typeTag) {
                this.typeTag = getTypeTag(this.typeTag, true);
            }
        });
    },
    computed: {
        queryParameters() {
            const qs = queryString.parse(window.location.search);
            if (this.query) qs.q = this.query;
            if (this.typeTag) qs.type = this.typeTag;
            if (this.guid) qs.guid = this.guid;
            return qs;
        },
        querySearch() {
            return window.location.search;
        },
    },
    methods: {
        isCurrentRoute(routeName) {
            if (this.$route) return this.$route.name == routeName;
            return routeName == "Web";
        },
        setCurrentMode(navItem) {
            this.currentMode = navItem;
            this.$emit("setCurrentMode", navItem);
            trackGA("click", { label: this.currentMode.name });
        },
    },
};
</script>
